import { memo, useEffect, useId, useRef } from 'react';

import { PrivateWorkspaceAgentPanelComposerArchivedSessionMessage } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/PrivateWorkspaceAgentPanelComposerArchivedSessionMessage';

export const PrivateWorkspaceAgentPanelComposerArchivedSessionDock = memo(() => {
  const dockRef = useRef<HTMLElement>(null);
  const headingId = useId();

  useEffect(() => {
    dockRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <section
      aria-labelledby={headingId}
      className="relative flex w-full shrink-0 flex-col overflow-hidden rounded-8 border-0 ads:bg-subtle bg-gray-3 p-2.5 outline-none transition-shadow ads:focus-within:ring-focus focus-within:ring-2 focus-within:ring-altitude-9 ads:focus:ring-focus focus:ring-2 focus:ring-altitude-9"
      data-testid="WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_BANNER"
      ref={dockRef}
      tabIndex={-1}
    >
      <PrivateWorkspaceAgentPanelComposerArchivedSessionMessage headingId={headingId} />
    </section>
  );
});

PrivateWorkspaceAgentPanelComposerArchivedSessionDock.displayName =
  'PrivateWorkspaceAgentPanelComposerArchivedSessionDock';
